if (!customElements.get('sticky-checkout')) {
	class StickyCheckout extends HTMLElement {
		constructor() {
			super();

			this.stickyHeader = document.querySelector('.shopify-section-header-sticky');
			this.headerOffset = this.stickyHeader ? this.stickyHeader.offsetHeight : 0;
			this.footer = document.querySelector('footer');
			this.footer?.classList.add('footer--sticky-atc-enabled');
		}

		connectedCallback() {
			this.createObserver();
		}

		disconnectedCallback() {
			this.observer.disconnect();
		}
		createObserver() {
			const observerOptions = {
				rootMargin: this.headerOffset > 0 ? `-${this.headerOffset}px 0px` : '0px',
			};
			this.observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					const headerOffset = this.stickyHeader?.classList.contains('shopify-section-header-hidden')
						? 0
						: this.headerOffset;
					const isUnderViewport =
						entry.boundingClientRect.top > window.innerHeight - headerOffset &&
						entry.boundingClientRect.bottom > window.innerHeight - headerOffset;
					// subtract stickyHeader height from window.innerHeight
					const isVisible =
						entry.boundingClientRect.top < window.innerHeight - headerOffset &&
						entry.boundingClientRect.bottom >= headerOffset;
					if (isVisible) {
						requestAnimationFrame(this.hide.bind(this));
					} else {
						requestAnimationFrame(this.reveal.bind(this));
					}
				});
			}, observerOptions);
			this.observer.observe(this.parentElement);
		}
		hide() {
			this.classList.remove('sticky');
		}

		reveal() {
			this.classList.add('sticky');
		}
	}

	customElements.define('sticky-checkout', StickyCheckout);
}
